import React from 'react';
import PropTypes from 'prop-types';
import { SmallWidget } from '../assets/styled';

function Widgets({ type, title, numberData, accentColor }) {
  return (
    <>
      {type === 'sm' ? (
        <SmallWidget accentColor={accentColor}>
          <div className="content">
            <h6>{title}</h6>
            <h5>{numberData}</h5>
          </div>
        </SmallWidget>
      ) : null}
    </>
  );
}

Widgets.propTypes = {
  type: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  numberData: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  accentColor: PropTypes.string,
};

export default Widgets;